export enum HireTypeEnum {
  employee = 'employee',
  contractor = 'contractor',
}
